/**
 * engineering.js — 혁신공과대학 이수요건 데이터
 * 출처: 2026학년도 전공 교육과정 (2026_major.pdf)
 */

export const ENGINEERING_REQUIREMENTS = [

  // ── 전자공학부 / 2026학번 / 1학년 1학기 ──────────────────────────────────────
  {
    id:             'elec_2026_1_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'elec',
    departmentName: '전자공학부',
    majorId:        'elec_main',
    majorName:      '전자공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '수학1',            courseCode: '03747', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학1'] },
      { courseName: '컴퓨터프로그래밍1', courseCode: '06599', type: '전공필수', credits: 3, required: true, matchKeywords: ['컴퓨터프로그래밍1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터 (전기전자공학부 공통 과목)'],
  },

  // ── 전자공학부 / 2026학번 / 1학년 2학기 ──────────────────────────────────────
  {
    id:             'elec_2026_1_2',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'elec',
    departmentName: '전자공학부',
    majorId:        'elec_main',
    majorName:      '전자공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '물리학및실험2',    courseCode: '02525', type: '기초교양', credits: 3, required: true, matchKeywords: ['물리학및실험2'] },
      { courseName: '수학2',            courseCode: '03751', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학2'] },
      { courseName: '컴퓨터프로그래밍2', courseCode: '06601', type: '전공필수', credits: 3, required: true, matchKeywords: ['컴퓨터프로그래밍2'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 기계공학부 / 2026학번 / 1학년 1학기 ──────────────────────────────────────
  {
    id:             'mech_2026_1_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'mech',
    departmentName: '기계공학부',
    majorId:        'mech_main',
    majorName:      '기계공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '물리학및실험1', courseCode: '02522', type: '기초교양', credits: 3, required: true, matchKeywords: ['물리학및실험1'] },
      { courseName: '수학1',        courseCode: '03747', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 기계공학부 / 2026학번 / 1학년 2학기 ──────────────────────────────────────
  {
    id:             'mech_2026_1_2',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'mech',
    departmentName: '기계공학부',
    majorId:        'mech_main',
    majorName:      '기계공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '물리학및실험2', courseCode: '02525', type: '기초교양', credits: 3, required: true, matchKeywords: ['물리학및실험2'] },
      { courseName: '수학2',        courseCode: '03751', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학2'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 기계공학부 / 2025학번 / 2학년 1학기 ──────────────────────────────────────
  {
    id:             'mech_2025_2_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'mech',
    departmentName: '기계공학부',
    majorId:        'mech_main',
    majorName:      '기계공학전공',
    admissionYear:  2025,
    grade:          2,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '고체역학',       courseCode: '00753', type: '전공필수', credits: 3, required: true, matchKeywords: ['고체역학'] },
      { courseName: '공업수학1',      courseCode: '00812', type: '전공필수', credits: 3, required: true, matchKeywords: ['공업수학1'] },
      { courseName: '열역학',         courseCode: '08293', type: '전공필수', credits: 3, required: true, matchKeywords: ['열역학'] },
      { courseName: '창의적공학설계', courseCode: '08701', type: '전공필수', credits: 3, required: true, matchKeywords: ['창의적공학설계'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 화학공학과 / 2026학번 / 1학년 1학기 ──────────────────────────────────────
  {
    id:             'chem_2026_1_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'chem',
    departmentName: '화학공학과',
    majorId:        'chem_main',
    majorName:      '화학공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '수학1',       courseCode: '03747', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학1'] },
      { courseName: '화학및실험1', courseCode: '07576', type: '기초교양', credits: 3, required: true, matchKeywords: ['화학및실험1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터 (화학공학·신소재공학부 공통 과목)'],
  },

  // ── 화학공학과 / 2026학번 / 1학년 2학기 ──────────────────────────────────────
  {
    id:             'chem_2026_1_2',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'chem',
    departmentName: '화학공학과',
    majorId:        'chem_main',
    majorName:      '화학공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '수학2',       courseCode: '03751', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학2'] },
      { courseName: '화학및실험2', courseCode: '07579', type: '기초교양', credits: 3, required: true, matchKeywords: ['화학및실험2'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 화학공학과 / 2025학번 / 2학년 1학기 ──────────────────────────────────────
  {
    id:             'chem_2025_2_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'chem',
    departmentName: '화학공학과',
    majorId:        'chem_main',
    majorName:      '화학공학전공',
    admissionYear:  2025,
    grade:          2,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '공업수학1', courseCode: '00812', type: '전공필수', credits: 3, required: true, matchKeywords: ['공업수학1'] },
      { courseName: '물리화학1', courseCode: '08660', type: '전공필수', credits: 3, required: true, matchKeywords: ['물리화학1'] },
      { courseName: '유기화학1', courseCode: '08662', type: '전공필수', credits: 3, required: true, matchKeywords: ['유기화학1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 토목환경공학부 / 데이터 미입력 ───────────────────────────────────────────
  {
    id:             'civil_2026_1_1',
    collegeId:      'engineering',
    collegeName:    '혁신공과대학',
    departmentId:   'civil',
    departmentName: '토목환경공학부',
    majorId:        'civil_ce',
    majorName:      '건설환경공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'sample',
    requiredCourses: [],
    recommendedCourses: [],
    graduationRules: { totalCredits: null, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['데이터 준비 중 — 학과 교육과정표를 확인하세요'],
  },
]
